//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/SelectNXObject.js";
import "../no/SelectObject.js";
let d=[[[0,"NewSurfaceLayer",1,0],[1,"SourceObject",0,"SelectNXObject",0]],[[["trimPart","sourceObjectOcc","currentTrimSurfaceName","previousTrimSurfaceName"],"SetTrimDataDetails",{},4,0],[["partName","instanceName"],"CreateNewComponent",{R_:{newComponent:"Assemblies.Component"}},2,0],[["surfaceName","trimPart","sheetType","layer"],"CreateDefaultSheet",{R_:{sheetBody:"NXObject"}},4,0]],[]];
SPLM.Tooling.DesignTrimToolBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.DesignTrimToolBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;